import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Path, PathGenerator, ExternalPath } from "../../constants/path";
import { settings } from "../../assets/settings";
import { Link, Button } from "../util/Clickable";
import Plan from "./Plan";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-142451086-2');
ReactGA.pageview(window.location.pathname + window.location.search);

declare var UIkit;

class PlanList extends Component {

  state = {
    sort: "recomend"
  }

  sort = (sort)=> {
    this.setState({
      sort: sort
    })
  }

  getSortedPlan = () => {
    var plans = this.props.plans;
    plans = plans.filter( (plan) => {
      return  plan.Plan.indexOf(settings.recomend_key) != -1;
    });
    if( this.state.sort == "recomend" ){
      // this.props.plans.sort( (a, b) => {
      //   if( a.Plan && b.Plan ){
      //     if( a.Plan.indexOf(settings.recomend_key) != -1 && b.Plan.indexOf(settings.recomend_key) == -1 ){
      //       return -1;
      //     }else if( a.Plan.indexOf(settings.recomend_key) == -1 && b.Plan.indexOf(settings.recomend_key) != -1 ){
      //       return 1;
      //     }
      //   }
      //   if(+a.Price > +b.Price){
      //     return -1;
      //   }else{
      //     return 1;
      //   }
      // });
      
    }else if( this.state.sort == "expensive" ){
      plans.sort( (a, b) => {
        if(+a.Price > +b.Price){
          return -1;
        }else{
          return 1;
        }
      });
    }else if( this.state.sort == "cheap" ) {
      plans.sort( (a, b) => {
        if(+a.Price < +b.Price){
          return -1;
        }else{
          return 1;
        }
      });
    }
    if( settings.max_plan_size == -1 ){
      return plans;
    }else{
      return plans.slice(0, settings.max_plan_size);  
    }
  }

  render = () => {
    var plans = this.props.plans;
    if( !plans || plans.length == 0 ){
      return (
        <p>
          <span>条件に該当するプランがありません。
            {
            this.props.facility.home_url && (
            <span>(
              <ReactGA.OutboundLink eventLabel={"詳細 > " + this.props.facility.name + " 公式・他のプラン  > " + this.props.facility.home_url} to={this.props.facility.home_url} target="_blank">
                公式サイトで他のプランを見る
              </ReactGA.OutboundLink>
            )</span>
              )
            }
          </span>
        </p>
      );
    }
    plans = this.getSortedPlan();

    return (
      <div className="">
        <div className="uk-margin uk-background-muted uk-padding-small uk-sorter">
          <a className={"uk-margin-small-right "+ (this.state.sort == "recomend" ? "active": "") } onClick={() => this.sort("recomend")}>
            おすすめ順
          </a>
          <a className={"uk-margin-small-right "+ (this.state.sort == "cheap" ? "active": "") } onClick={() => this.sort("cheap")}>
            安い順
          </a>
          <a className={"uk-margin-small-right "+ (this.state.sort == "expensive" ? "active": "") } onClick={() => this.sort("expensive")}>
            高い順
          </a>
        </div>
        <div className="uk-margin uk-padding-small uk-box-shadow-small">
        {( () => {
          if(plans == null || plans.length == 0){
            return (
              <div>
                該当するプランがありません。
              </div>
            );
          }else{
            return plans.map( (plan, index) => {
              return (
                <div key={index}>
                  <Plan plan={plan} />
                </div>
              );
            });
          }
        } )()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlanList))
